import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PageHeaderProps {
  children: ReactNode;
  className?: string;
  variant?: 'default' | 'detailed';
}

export function PageHeader({
  children,
  className,
  variant = 'default',
}: PageHeaderProps) {
  if (variant === 'detailed') {
    return (
      <div
        className={cn(
          'flex flex-col gap-2 border-b pb-6 border-border bg-background px-6 py-6 bg-background ',
          className
        )}
      >
        {children}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between border-b border-border bg-background px-10 py-6 bg-background ">
      {children}
    </div>
  );
}

interface PageContentProps {
  children: ReactNode;
  className?: string;
}

export function PageContent({ children, className }: PageContentProps) {
  return <div className={cn('px-6 py-4', className)}>{children}</div>;
}

interface PageTitleProps {
  children: ReactNode;
  className?: string;
  variant?: 'default' | 'detailed';
}

export function PageTitle({ children, className }: PageTitleProps) {
  return <h1 className={cn('text-3xl semibold', className)}>{children}</h1>;
}

interface PageDescriptionProps {
  children: ReactNode;
  className?: string;
}

export function PageDescription({ children, className }: PageDescriptionProps) {
  return <p className={cn('text-muted-foreground', className)}>{children}</p>;
}

interface PageActionProps {
  children: ReactNode;
  className?: string;
}

export function PageAction({ children, className }: PageActionProps) {
  return <div className={cn('', className)}>{children}</div>;
}

interface PageHeaderContentProps {
  children: ReactNode;
  className?: string;
  variant?: 'default' | 'detailed';
}

export function PageHeaderContent({
  children,
  className,
  variant = 'default',
}: PageHeaderContentProps) {
  if (variant === 'detailed') {
    return (
      <div
        className={cn('flex items-start justify-between pr-12 pl-4', className)}
      >
        {children}
      </div>
    );
  }

  return <div className={cn('', className)}>{children}</div>;
}

interface PageHeaderInfoProps {
  children: ReactNode;
  className?: string;
  variant?: 'default' | 'detailed';
}

export function PageHeaderInfo({ children, className }: PageHeaderInfoProps) {
  return <div className={cn('flex flex-col gap-3', className)}>{children}</div>;
}

interface PageHeaderLabelProps {
  children: ReactNode;
  className?: string;
}

export function PageHeaderLabel({ children, className }: PageHeaderLabelProps) {
  return (
    <div
      className={cn(
        'text-muted-foreground text-xs tracking-wider uppercase',
        className
      )}
    >
      {children}
    </div>
  );
}
